import { render, staticRenderFns } from "./referralOrderDetail.vue?vue&type=template&id=76828c08&scoped=true&"
import script from "./referralOrderDetail.vue?vue&type=script&lang=js&"
export * from "./referralOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./referralOrderDetail.vue?vue&type=style&index=0&id=76828c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76828c08",
  null
  
)

export default component.exports